/**
 * Error messages translations
 * Error message UI text
 */

import { LANGUAGES } from '../config';

export const errorsTranslations = {
  [LANGUAGES.EN]: {
    genericError: 'An error occurred. Please try again.',
    loginError: 'Invalid email or password',
    registrationError: 'Registration failed',
    permissionDenied: 'Permission denied',
    notFound: 'Not found',
    serverError: 'Server error',
    networkError: 'Network error',
    validationError: 'Validation error',
    companyNameRequired: 'Company name is required',
    companyResearchRequired: 'Company research is required before analyzing job postings. Please complete company research first.',
    saveError: 'Error saving {type}. Please try again.',
    fileUploadError: 'Error uploading file. Please try again.',
    fileTypeError: 'File type not supported',
    fileSizeError: 'File size exceeds maximum limit'
  },
  [LANGUAGES.FR]: {
    genericError: 'Une erreur s\'est produite. Veuillez réessayer.',
    loginError: 'Email ou mot de passe invalide',
    registrationError: 'L\'inscription a échoué',
    permissionDenied: 'Permission refusée',
    notFound: 'Non trouvé',
    serverError: 'Erreur du serveur',
    networkError: 'Erreur de réseau',
    validationError: 'Erreur de validation',
    companyNameRequired: 'Le nom de l\'entreprise est requis',
    companyResearchRequired: 'La recherche d\'entreprise est requise avant d\'analyser les offres d\'emploi. Veuillez d\'abord effectuer la recherche d\'entreprise.',
    saveError: 'Erreur lors de l\'enregistrement de {type}. Veuillez réessayer.',
    fileUploadError: 'Erreur lors du téléversement du fichier. Veuillez réessayer.',
    fileTypeError: 'Type de fichier non pris en charge',
    fileSizeError: 'La taille du fichier dépasse la limite maximale'
  }
};
